// extracted by mini-css-extract-plugin
module.exports = {"pdf_frame":"pdfdoc-module--pdf_frame--2b4-K","pdf_txt":"pdfdoc-module--pdf_txt--9SIgD"};